import { computed } from 'vue'

import { createBackboxObjectId } from '@backmarket/nuxt-layer-recommendation/helpers.ts'

import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

export function useProductUrlToAlgoliaObjectId() {
  const { grade, productId, offerType } = useUrlParams()

  return computed(() => {
    if (!grade.value) return null

    return createBackboxObjectId(productId, grade.value, offerType.value ?? 0)
  })
}
